module.exports = web3dPluginTrimbim;